var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useEffect } from 'react';
import useCountriesList from './useCountriesList';
import useGooglePlacesAutocomplete from './useGooglePlacesAutocomplete';
import useGooglePlacesDetails from './useGooglePlacesDetails';
var initialAddressState = {
    city: '',
    country: '',
    street: '',
    streetNumber: '',
    zipCode: ''
};
var useAutofillForm = function (handleClearError) {
    var _a = useState(''), query = _a[0], setQuery = _a[1];
    var _b = useState(''), selectedPlaceId = _b[0], setSelectedPlaseId = _b[1];
    var predictions = useGooglePlacesAutocomplete(query);
    var placesDetails = useGooglePlacesDetails(selectedPlaceId);
    var countriesList = useCountriesList();
    var _c = useState(initialAddressState), address = _c[0], setAddress = _c[1];
    var _d = useState(''), addressInputValue = _d[0], setAddressInputValue = _d[1];
    var _e = useState(''), selectedCountry = _e[0], setSelectedCountry = _e[1];
    var _f = useState(''), countryInputValue = _f[0], setCountryInputValue = _f[1];
    var _g = useState(false), isInputClicked = _g[0], setIsInputClicked = _g[1];
    var _h = useState(''), countryError = _h[0], setCountryError = _h[1];
    var _j = useState([]), filteredCountries = _j[0], setFilteredCountries = _j[1];
    var _k = useState(false), isCountryInputUserTyped = _k[0], setIsCountryInputUserTyped = _k[1];
    var fieldAddress = {
        country: 'country',
        locality: 'city',
        postal_code: 'zipCode',
        route: 'street',
        street_number: 'streetNumber',
    };
    var handleAddressChange = function (event) {
        setQuery(event.target.value);
    };
    var handleCountryChange = function (event) {
        var userInput = event.target.value;
        setCountryInputValue(userInput);
        setIsCountryInputUserTyped(true);
        setCountryError('');
    };
    var handleSelectedValueChange = function (newValuePlaceId) {
        setSelectedPlaseId(newValuePlaceId);
    };
    var handleSelectedCountry = function (country) {
        setSelectedCountry(country);
        setCountryInputValue(country);
        setIsInputClicked(false);
        setCountryError('');
    };
    var handleInputClickDropdownVisible = function () {
        setIsInputClicked(true);
    };
    var getAddressPart = function (inputId) {
        return address[inputId];
    };
    useEffect(function () {
        if (placesDetails) {
            placesDetails.address_components.forEach(function (component) {
                var field = fieldAddress[component.types.find(function (type) { return fieldAddress[type]; }) || ''];
                if (field) {
                    setAddress(function (prevAddress) {
                        var _a;
                        return (__assign(__assign({}, prevAddress), (_a = {}, _a[field] = component.long_name, _a)));
                    });
                }
                if (field === 'country' && component.long_name !== selectedCountry) {
                    handleSelectedCountry(component.long_name);
                }
                handleClearError(field);
            });
        }
    }, [placesDetails]);
    useEffect(function () {
        if (isInputClicked) {
            var filtered = countriesList.payload.filter(function (country) {
                return country.toLowerCase().includes(countryInputValue.toLowerCase());
            });
            setFilteredCountries(filtered);
        }
    }, [countriesList, countryInputValue, isInputClicked]);
    return {
        address: address,
        addressInputValue: addressInputValue,
        countryError: countryError,
        countryInputValue: countryInputValue,
        filteredCountries: filteredCountries,
        getAddressPart: getAddressPart,
        handleAddressChange: handleAddressChange,
        handleCountryChange: handleCountryChange,
        handleInputClickDropdownVisible: handleInputClickDropdownVisible,
        handleSelectedCountry: handleSelectedCountry,
        handleSelectedValueChange: handleSelectedValueChange,
        isCountryInputUserTyped: isCountryInputUserTyped,
        placesDetails: placesDetails,
        predictions: predictions,
        query: query,
        selectedCountry: selectedCountry,
        selectedPlaceId: selectedPlaceId,
        setAddress: setAddress,
        setAddressInputValue: setAddressInputValue,
        setCountryError: setCountryError,
        setCountryInputValue: setCountryInputValue,
        setQuery: setQuery,
        setSelectedPlaseId: setSelectedPlaseId,
    };
};
export default useAutofillForm;
